module.exports = __webpack_public_path__ + "img/cosmetic_face.937fdcbb.svg";